import { getCurrentAppByHostname } from '../../Helpers';
import { ReportListFilters, ReportPreFilter } from '../../Models/ReportValue';
import { ReportListQuerySortBy } from '../ReportService';
import { ReportListGroupedBy } from '../../Components/ReportList/ReportSortGroupByButton/ReportSortGroupByButtonMenu/ReportSortGroupByButtonMenu';

const AdvancedSearchStorage = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
}.AdvancedSearchConfig`;

export interface AdvancedSearchConfigType {
  preFilter: ReportPreFilter | undefined;
  filters: ReportListFilters | undefined;
  sortBy: ReportListQuerySortBy;
  groupedBy: ReportListGroupedBy;
  wsId?: string;
}

export const getAdvancedSearchConfig = (
  wsId?: string
): AdvancedSearchConfigType => {
  const storageKey = wsId
    ? `${AdvancedSearchStorage}.WS_ID.${wsId}`
    : AdvancedSearchStorage;
  return localStorage.getItem(storageKey)
    ? JSON.parse(localStorage.getItem(storageKey) as string)
    : {
        preFilter: undefined,
        filters: undefined,
        sortBy: 'newest',
        groupedBy: 'report'
      };
};

export const setAdvancedSearchConfig = (
  filters: AdvancedSearchConfigType,
  wsId?: string
): void => {
  const storageKey = wsId
    ? `${AdvancedSearchStorage}.WS_ID.${wsId}`
    : AdvancedSearchStorage;
  localStorage.setItem(storageKey, JSON.stringify(filters));
};
